import { createBrowserRouter } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import AdminRoutes from "./AdminRoutes";
import NotFound from "../pages/notfound";
const router = createBrowserRouter([
  AuthRoutes,
  AdminRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
]);
export default router;
